// components/LanguageSelector.jsx
import React, { useContext, useState } from "react";
import styles from "./LanguageSelector.module.scss";
import MainButton from "../MainButton/MainButton.jsx";
import { LanguageContext } from "../../contexts/LanguageContext";
import { languages } from "../../ui_languages/index.js";
import { log } from "../../utils/logger.js";

const LanguageSelector = () => {
  const { updateLanguage } = useContext(LanguageContext);
  const [selectedLanguage, setSelectedLanguage] = useState(null);

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.value);
  };

  const handleContinue = async () => {
    if (selectedLanguage) {
      log(selectedLanguage);
      await updateLanguage(selectedLanguage);
      log("saved language", selectedLanguage);
    }
  };

  // Split languages into two columns
  const midpoint = Math.ceil(languages.length / 2);
  const leftColumn = languages.slice(0, midpoint);
  const rightColumn = languages.slice(midpoint);

  return (
    <div className={styles.languageSelector}>
      <h2 className={styles.title}>Choose the language</h2>
      <div className={styles.languageOptions}>
        <div className={styles.column}>
          {leftColumn.map((lang, index) => (
            <label className={styles.label} key={index}>
              <input
                type="radio"
                name="language"
                value={lang.key} // Use key to save language name
                onChange={handleLanguageChange}
              />
              {lang.name}
            </label>
          ))}
        </div>
        <div className={styles.column}>
          {rightColumn.map((lang, index) => (
            <label className={styles.label} key={index + midpoint}>
              <input
                type="radio"
                name="language"
                value={lang.key} // Use key to save language name
                onChange={handleLanguageChange}
              />
              {lang.name}
            </label>
          ))}
        </div>
      </div>
      <MainButton
        disabled={!selectedLanguage}
        size={"large"}
        onClick={handleContinue}
      >
        Continue
      </MainButton>
    </div>
  );
};

export default LanguageSelector;
